var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("p", { staticClass: "title" }, [_vm._v("Filtros")]),
    !_vm.isFiltroProcesso
      ? _c(
          "div",
          [
            _c(
              "el-row",
              { attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  { staticClass: "container-input mb", attrs: { span: 8 } },
                  [
                    _c("app-label", {
                      attrs: { label: "Município", required: false }
                    }),
                    _c(
                      "el-select",
                      {
                        staticClass: "input select",
                        attrs: {
                          multiple: "multiple",
                          disabled: _vm.isTecnicoMunicipal,
                          "multiple-limit": _vm.isGrafico ? 60 : 0,
                          "collapse-tags": "collapse-tags",
                          filterable: "filterable",
                          placeholder: "Selecione",
                          "value-key": "id"
                        },
                        model: {
                          value: _vm.filtroPrincipal.listIdMunicipio,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.filtroPrincipal,
                              "listIdMunicipio",
                              $$v
                            )
                          },
                          expression: "filtroPrincipal.listIdMunicipio"
                        }
                      },
                      _vm._l(_vm.municipioList, function(municipio) {
                        return _c("el-option", {
                          key: municipio.id,
                          attrs: { label: municipio.label, value: municipio.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { staticClass: "container-input mb", attrs: { span: 8 } },
                  [
                    _c("app-label", {
                      attrs: { label: "Ordem de serviço", required: false }
                    }),
                    _c(
                      "el-select",
                      {
                        staticClass: "input select",
                        attrs: {
                          multiple: "multiple",
                          "multiple-limit": _vm.isGrafico ? 60 : 0,
                          "collapse-tags": "collapse-tags",
                          filterable: "filterable",
                          placeholder: "Selecione",
                          "value-key": "id"
                        },
                        model: {
                          value: _vm.filtroPrincipal.listIdOrdemServico,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.filtroPrincipal,
                              "listIdOrdemServico",
                              $$v
                            )
                          },
                          expression: "filtroPrincipal.listIdOrdemServico"
                        }
                      },
                      _vm._l(_vm.osList, function(os) {
                        return _c("el-option", {
                          key: os.id,
                          attrs: { label: os.numero, value: os.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { staticClass: "container-input mb", attrs: { span: 8 } },
                  [
                    _c("app-label", {
                      attrs: { label: "Período de cadastro", required: false }
                    }),
                    _c("el-date-picker", {
                      attrs: {
                        type: "daterange",
                        "unlink-panels": "unlink-panels",
                        "range-separator": "até",
                        "start-placeholder": "Início",
                        "end-placeholder": "Fim",
                        format: "dd/MM/yyyy",
                        "picker-options": _vm.pickerOptions
                      },
                      model: {
                        value: _vm.filtroPrincipal.periodo,
                        callback: function($$v) {
                          _vm.$set(_vm.filtroPrincipal, "periodo", $$v)
                        },
                        expression: "filtroPrincipal.periodo"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  { staticClass: "container-input mb", attrs: { span: 8 } },
                  [
                    _c("app-label", {
                      attrs: { label: "Cadastrante", required: false }
                    }),
                    _c(
                      "el-select",
                      {
                        staticClass: "select",
                        attrs: {
                          multiple: "multiple",
                          "multiple-limit": _vm.isGrafico ? 60 : 0,
                          "collapse-tags": "collapse-tags",
                          filterable: "filterable",
                          remote: "remote",
                          "remote-method": _vm.getListaCadastrantes,
                          "value-key": "nome",
                          placeholder: ""
                        },
                        model: {
                          value: _vm.filtroPrincipal.listIdCadastrante,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.filtroPrincipal,
                              "listIdCadastrante",
                              $$v
                            )
                          },
                          expression: "filtroPrincipal.listIdCadastrante"
                        }
                      },
                      _vm._l(_vm.cadastranteList, function(cadastrante) {
                        return _c("el-option", {
                          key: cadastrante.id,
                          attrs: {
                            label: cadastrante.nome,
                            value: cadastrante.id
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { staticClass: "container-input mb", attrs: { span: 8 } },
                  [
                    _c("app-label", {
                      attrs: { label: "Perfil", required: false }
                    }),
                    _c(
                      "el-select",
                      {
                        staticClass: "input select",
                        attrs: {
                          multiple: "multiple",
                          "multiple-limit": 2,
                          "collapse-tags": "collapse-tags",
                          filterable: "filterable",
                          placeholder: "Selecione",
                          "value-key": "id"
                        },
                        model: {
                          value: _vm.filtroPrincipal.listIdPerfilCadastrante,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.filtroPrincipal,
                              "listIdPerfilCadastrante",
                              $$v
                            )
                          },
                          expression: "filtroPrincipal.listIdPerfilCadastrante"
                        }
                      },
                      _vm._l(_vm.perfilList, function(perfil) {
                        return _c("el-option", {
                          key: perfil.id,
                          attrs: { label: perfil.nome, value: perfil.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { staticClass: "container-input mb", attrs: { span: 8 } },
                  [
                    _c("app-label", {
                      attrs: { label: "Endereço", required: false }
                    }),
                    _c("el-input", {
                      staticClass: "input",
                      attrs: { placeholder: "" },
                      model: {
                        value: _vm.filtroPrincipal.endereco,
                        callback: function($$v) {
                          _vm.$set(_vm.filtroPrincipal, "endereco", $$v)
                        },
                        expression: "filtroPrincipal.endereco"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  { staticClass: "container-input mb", attrs: { span: 8 } },
                  [
                    _c("app-label", {
                      attrs: { label: "Bairro", required: false }
                    }),
                    _c("el-input", {
                      staticClass: "input-bairro",
                      attrs: { placeholder: "" },
                      model: {
                        value: _vm.filtroPrincipal.bairro,
                        callback: function($$v) {
                          _vm.$set(_vm.filtroPrincipal, "bairro", $$v)
                        },
                        expression: "filtroPrincipal.bairro"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      : _c(
          "div",
          [
            _c(
              "el-row",
              { attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  { staticClass: "container-input mb", attrs: { span: 8 } },
                  [
                    _c("app-label", {
                      attrs: { label: "Município", required: false }
                    }),
                    _c(
                      "el-select",
                      {
                        staticClass: "input select",
                        attrs: {
                          multiple: "multiple",
                          disabled: _vm.isTecnicoMunicipal,
                          "collapse-tags": "collapse-tags",
                          filterable: "filterable",
                          placeholder: "Selecione",
                          "value-key": "id"
                        },
                        model: {
                          value: _vm.filtroProcesso.listIdMunicipio,
                          callback: function($$v) {
                            _vm.$set(_vm.filtroProcesso, "listIdMunicipio", $$v)
                          },
                          expression: "filtroProcesso.listIdMunicipio"
                        }
                      },
                      _vm._l(_vm.municipioList, function(municipio) {
                        return _c("el-option", {
                          key: municipio.id,
                          attrs: { label: municipio.label, value: municipio.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { staticClass: "container-input mb", attrs: { span: 8 } },
                  [
                    _c("app-label", {
                      attrs: { label: "Ordem de serviço", required: false }
                    }),
                    _c(
                      "el-select",
                      {
                        staticClass: "input select",
                        attrs: {
                          "collapse-tags": "collapse-tags",
                          multiple: "multiple",
                          filterable: "filterable",
                          placeholder: "Selecione",
                          "value-key": "id"
                        },
                        model: {
                          value: _vm.filtroProcesso.listIdOrdemServico,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.filtroProcesso,
                              "listIdOrdemServico",
                              $$v
                            )
                          },
                          expression: "filtroProcesso.listIdOrdemServico"
                        }
                      },
                      _vm._l(_vm.osList, function(os) {
                        return _c("el-option", {
                          key: os.id,
                          attrs: { label: os.numero, value: os.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { staticClass: "container-input mb", attrs: { span: 8 } },
                  [
                    _c("app-label", {
                      attrs: { label: "Número do processo", required: false }
                    }),
                    _c("el-input", {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: ["#########/####"],
                          expression: "['#########/####']"
                        }
                      ],
                      staticClass: "input",
                      model: {
                        value: _vm.filtroProcesso.numeroProcesso,
                        callback: function($$v) {
                          _vm.$set(_vm.filtroProcesso, "numeroProcesso", $$v)
                        },
                        expression: "filtroProcesso.numeroProcesso"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  { staticClass: "container-input mb", attrs: { span: 8 } },
                  [
                    _c("app-label", {
                      attrs: { label: "Cadastrante", required: false }
                    }),
                    _c(
                      "el-select",
                      {
                        staticClass: "select",
                        attrs: {
                          multiple: "multiple",
                          "collapse-tags": "collapse-tags",
                          filterable: "filterable",
                          remote: "remote",
                          "remote-method": _vm.getListaCadastrantes,
                          "value-key": "nome",
                          placeholder: ""
                        },
                        model: {
                          value: _vm.filtroProcesso.listIdCadastrante,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.filtroProcesso,
                              "listIdCadastrante",
                              $$v
                            )
                          },
                          expression: "filtroProcesso.listIdCadastrante"
                        }
                      },
                      _vm._l(_vm.cadastranteList, function(cadastrante) {
                        return _c("el-option", {
                          key: cadastrante.id,
                          attrs: {
                            label: cadastrante.nome,
                            value: cadastrante.id
                          }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { staticClass: "container-input mb", attrs: { span: 8 } },
                  [
                    _c("app-label", {
                      attrs: { label: "Nome do interessado", required: false }
                    }),
                    _c("el-input", {
                      staticClass: "input",
                      model: {
                        value: _vm.filtroProcesso.nomeInteressado,
                        callback: function($$v) {
                          _vm.$set(_vm.filtroProcesso, "nomeInteressado", $$v)
                        },
                        expression: "filtroProcesso.nomeInteressado"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { staticClass: "container-input", attrs: { span: 8 } },
                  [
                    _c("app-label", {
                      attrs: { label: "CPF do interessado", required: false }
                    }),
                    _c("el-input", {
                      directives: [
                        {
                          name: "mask",
                          rawName: "v-mask",
                          value: ["###.###.###-##"],
                          expression: "['###.###.###-##']"
                        }
                      ],
                      staticClass: "input",
                      model: {
                        value: _vm.filtroProcesso.cpfCnpjInteressado,
                        callback: function($$v) {
                          _vm.$set(
                            _vm.filtroProcesso,
                            "cpfCnpjInteressado",
                            $$v
                          )
                        },
                        expression: "filtroProcesso.cpfCnpjInteressado"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  { staticClass: "container-input mb", attrs: { span: 8 } },
                  [
                    _c("app-label", {
                      attrs: { label: "Período de cadastro", required: false }
                    }),
                    _c("el-date-picker", {
                      attrs: {
                        type: "daterange",
                        "unlink-panels": "unlink-panels",
                        "range-separator": "até",
                        "start-placeholder": "Início",
                        "end-placeholder": "Fim",
                        format: "dd/MM/yyyy",
                        "picker-options": _vm.pickerOptions
                      },
                      model: {
                        value: _vm.filtroProcesso.periodo,
                        callback: function($$v) {
                          _vm.$set(_vm.filtroProcesso, "periodo", $$v)
                        },
                        expression: "filtroProcesso.periodo"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { staticClass: "container-input mb", attrs: { span: 8 } },
                  [
                    _c("app-label", {
                      attrs: { label: "Perfil", required: false }
                    }),
                    _c(
                      "el-select",
                      {
                        staticClass: "input select",
                        attrs: {
                          multiple: "multiple",
                          "multiple-limit": 2,
                          "collapse-tags": "collapse-tags",
                          filterable: "filterable",
                          placeholder: "Selecione",
                          "value-key": "id"
                        },
                        model: {
                          value: _vm.filtroProcesso.listIdPerfilCadastrante,
                          callback: function($$v) {
                            _vm.$set(
                              _vm.filtroProcesso,
                              "listIdPerfilCadastrante",
                              $$v
                            )
                          },
                          expression: "filtroProcesso.listIdPerfilCadastrante"
                        }
                      },
                      _vm._l(_vm.perfilList, function(perfil) {
                        return _c("el-option", {
                          key: perfil.id,
                          attrs: { label: perfil.nome, value: perfil.id }
                        })
                      }),
                      1
                    )
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { staticClass: "container-input mb", attrs: { span: 8 } },
                  [
                    _c("app-label", {
                      attrs: { label: "Endereço", required: false }
                    }),
                    _c("el-input", {
                      staticClass: "input",
                      model: {
                        value: _vm.filtroProcesso.rua,
                        callback: function($$v) {
                          _vm.$set(_vm.filtroProcesso, "rua", $$v)
                        },
                        expression: "filtroProcesso.rua"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c(
              "el-row",
              { attrs: { type: "flex" } },
              [
                _c(
                  "el-col",
                  { staticClass: "container-input mb", attrs: { span: 8 } },
                  [
                    _c("app-label", {
                      attrs: { label: "Bairro", required: false }
                    }),
                    _c("el-input", {
                      staticClass: "input",
                      model: {
                        value: _vm.filtroProcesso.bairro,
                        callback: function($$v) {
                          _vm.$set(_vm.filtroProcesso, "bairro", $$v)
                        },
                        expression: "filtroProcesso.bairro"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { staticClass: "container-input mb", attrs: { span: 8 } },
                  [
                    _c("app-label", {
                      attrs: { label: "Lote", required: false }
                    }),
                    _c("el-input", {
                      staticClass: "input",
                      model: {
                        value: _vm.filtroProcesso.lote,
                        callback: function($$v) {
                          _vm.$set(_vm.filtroProcesso, "lote", $$v)
                        },
                        expression: "filtroProcesso.lote"
                      }
                    })
                  ],
                  1
                ),
                _c(
                  "el-col",
                  { staticClass: "container-input mb", attrs: { span: 8 } },
                  [
                    _c("app-label", {
                      attrs: { label: "Quadra", required: false }
                    }),
                    _c("el-input", {
                      staticClass: "input",
                      model: {
                        value: _vm.filtroProcesso.quadra,
                        callback: function($$v) {
                          _vm.$set(_vm.filtroProcesso, "quadra", $$v)
                        },
                        expression: "filtroProcesso.quadra"
                      }
                    })
                  ],
                  1
                )
              ],
              1
            ),
            _c("el-row", { attrs: { gutter: 10 } }, [
              _c(
                "div",
                { staticClass: "row" },
                [
                  _c("span", { on: { click: _vm.exibirBuscaPorLote } }, [
                    _c("p", { staticClass: "busca" }, [
                      _vm._v("Pesquisa por lote")
                    ])
                  ]),
                  _c(
                    "el-tooltip",
                    { attrs: { effect: "dark", placement: "top" } },
                    [
                      _c("i", { staticClass: "el-icon-info icon-info" }),
                      _c("template", { slot: "content" }, [
                        _vm._v(
                          " Para realizar a pesquisa de mais de um processo, insira a planilha contendo os números dos processos a serem pesquisados de acordo com o modelo a seguir. "
                        ),
                        _c(
                          "a",
                          {
                            staticClass: "btn-download",
                            on: { click: _vm.baixarModelo }
                          },
                          [_vm._v("(Baixar modelo)")]
                        )
                      ])
                    ],
                    2
                  )
                ],
                1
              ),
              _c(
                "div",
                [
                  _vm.showPesquisaLote
                    ? _c("app-upload-area", {
                        attrs: {
                          id: "lote",
                          target: "publico/upload",
                          fileType: _vm.validExtensions,
                          onSuccess: _vm.onSuccess,
                          documento: _vm.filtroProcesso.file,
                          hasDownloadButton: false
                        },
                        on: { removerDocumento: _vm.removerDocumento },
                        model: {
                          value: _vm.filtroProcesso.file,
                          callback: function($$v) {
                            _vm.$set(_vm.filtroProcesso, "file", $$v)
                          },
                          expression: "filtroProcesso.file"
                        }
                      })
                    : _vm._e()
                ],
                1
              )
            ])
          ],
          1
        ),
    _c("div", { staticClass: "container-pesquisa" }, [
      _c(
        "div",
        { staticClass: "button-pesquisa" },
        [
          _c(
            "el-button",
            {
              attrs: { type: "text" },
              on: {
                click: function($event) {
                  return _vm.resetPesquisa(!_vm.isFiltroProcesso)
                }
              }
            },
            [_vm._v("Limpar")]
          ),
          _c(
            "el-button",
            {
              attrs: { type: "primary" },
              on: {
                click: function($event) {
                  return _vm.pesquisar(!_vm.isFiltroProcesso)
                }
              }
            },
            [_c("i", { staticClass: "fal fa-search" }), _vm._v("  Pesquisar")]
          )
        ],
        1
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49f15938", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49f15938","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/relatorios_reurb/components/Filtro.vue
// module id = null
// module chunks = 